var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuideCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 703,
    height: 1837,
    viewBox: "0 0 703 1837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1836.11C404.944 1727.16 703 1357.41 703 918.057C703 478.7 404.944 108.958 0 0V596.539C96.2032 670.745 158.175 787.164 158.175 918.057C158.175 1048.95 96.2032 1165.37 0 1239.57V1836.11Z",
    fill: "url(#paint0_linear_306_771)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_771",
    x1: -506.383,
    y1: 69.2863,
    x2: 100.316,
    y2: 1557.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00976084,
    stopColor: "#2CC1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CC1BF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideCircle2);
export default __webpack_public_path__ + "static/media/Guide_Circle2.fe7c7a11edcbc1cf82faf14b39512cc4.svg";
export { ForwardRef as ReactComponent };